import { PageHeader } from '@/components/shared/page-header';
import { TableSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="Appointments" description="View and manage charging appointments" />
      <TableSkeleton columns={7} />
    </>
  );
}
